import gql from 'graphql-tag';

export const MY_RESILIENCE_ANCHORS = gql`
  query myResilienceAnchors {
    myResilienceAnchors
  }
`;
